__turbopack_context__.v({
  "className": "noto_naskh_arabic_bfa8c427-module__OQ8u3G__className",
  "variable": "noto_naskh_arabic_bfa8c427-module__OQ8u3G__variable",
});
